<template>
  <div class="flex flex-col py-4">
    <vs-col
      vs-w="12"
      vs-type="flex"
      vs-align="center"
      vs-justify="space-between"
    >
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="MapIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        >
        </feather-icon>
        <h4>Endereço</h4>
      </div>

      <vs-button
        class="mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-address' })"
      >
        Editar
      </vs-button>

      <vs-button
        class="sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-address' })"
      />
    </vs-col>

    <hr class="my-4 line" />

    <div class="flex">
      <div v-if="show()" class="flex flex-col">
        <ul class="activity-timeline mobile-hidden">
          <li>
            <div
              class="timeline-icon"
              :style="{ backgroundColor: color }"
              :key="`timeline-${index}`"
            >
              <feather-icon
                icon="MapIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              ></feather-icon>
            </div>

            <div v-if="_postalCode != ''" class="flex pl-1 my-1">
              <p><b>CEP: </b>{{ _postalCode }}</p>
            </div>

            <div v-if="_country != ''" class="flex pl-1 my-1">
              <p><b>Pais: </b>{{ _country }}</p>
            </div>

            <div v-if="_state != ''" class="flex pl-1 my-1">
              <p><b>Estado: </b>{{ _state }}</p>
            </div>

            <div v-if="_city != ''" class="flex pl-1 my-1">
              <p><b>Cidade: </b>{{ _city }}</p>
            </div>
          </li>
        </ul>

        <div class="sm:hidden">
          <div v-if="_postalCode != ''" class="flex pl-1 my-1">
            <p><b>CEP: </b>{{ _postalCode }}</p>
          </div>

          <div v-if="_country != ''" class="flex pl-1 my-1">
            <p><b>Pais: </b>{{ _country }}</p>
          </div>

          <div v-if="_state != ''" class="flex pl-1 my-1">
            <p><b>Estado: </b>{{ _state }}</p>
          </div>

          <div v-if="_city != ''" class="flex pl-1 my-1">
            <p><b>Cidade: </b>{{ _city }}</p>
          </div>
        </div>
      </div>
      <EmptyDetailCard
        v-else
        description="Você ainda não preencheu nenhuma informação de endereço..."
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  computed: {
    ...mapState("address", ["address"]),
    ...mapState("company", ["company"]),

    _postalCode() {
      return this.address != undefined || this.address != null
        ? this.address.postalcode
        : "";
    },

    _country() {
      return this.address != undefined || this.address != null
        ? this.address.country
        : "";
    },

    _state() {
      return this.address != undefined || this.address != null
        ? this.address.state
        : "";
    },

    _city() {
      return this.address != undefined || this.address != null
        ? this.address.city
        : "";
    },

    _addressNeighborhood() {
      return this.address != undefined || this.address != null
        ? this.address.address_neighborhood
        : "";
    },

    _address() {
      return this.address != undefined || this.address != null
        ? this.address.address
        : "";
    },

    _addressNumber() {
      return this.address != undefined || this.address != null
        ? this.address.address_number
        : "";
    },

    _addressComplement() {
      return this.address != undefined || this.address != null
        ? this.address.address_complement
        : "";
    },

    color() {
      return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
    },
  },

  methods: {
    show() {
      return (
        Object.keys(this.address).filter((key) => this.address[key] != "")
          .length > 1
      );
    },
  },

  components: {
    EmptyDetailCard,
  },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
